import routerOptions0 from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_bufferutil@4.0.8_db0@0.2.1_idb_bae1724a876f977685b42ce607353081/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/Users/junyaoc/Documents/lab/oxb-web-5-cf/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}